"use strict";

var _ = require("underscore");
var Metric = require("./metric");

var MetricsContainer = React.createClass({
  render: function(){
    var metrics = [];

    _.each(this.props.metrics, function(metric){
      if (metric.id) {
        metrics.push(<Metric {...metric} key={metric.id} />);
      }
    });

    return (metrics.length>0)?(
        <div className={this.props.className} key="1">{metrics}</div>
      ):null;
  }
});

module.exports = MetricsContainer;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/Metric/metrics-container.jsx